import { AppButton, AppNavLink, AppParagraph } from "@/shared/Components";
import type { FC } from "react";
import styles from "./styles.module.scss";

interface Props {
  title: string;
  subtitle: string;
  buttonText: string;
  path: string;
  onClick?: () => void;
}

export const FormHeader: FC<Props> = ({ title, subtitle, buttonText, path, onClick }) => {
  return (
    <div className={styles["form-header"]}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles["for-members"]}>
        <AppParagraph size="sm" className={styles["log-in-text"]}>
          {subtitle}
        </AppParagraph>
        <AppNavLink to={path}>
          <AppButton onClick={onClick} type="text" className={styles["login-button"]}>
            {buttonText}
          </AppButton>
        </AppNavLink>
      </div>
    </div>
  );
};
